// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2mgbX","alert":"SettungsInbox_alert__2EB_3"};